import { useEffect } from "react";
import useUSQSUndo from "../../../hooks/useUSQSUndo";
import useUSQS from "../../../hooks/useUSQS";

const useLoadQSToEdit = (
  axiosPrivate,
  qstoedit,
  setUSQS,
  setUSQSData,
  setPpaymentterm,
  setPpaymenttermData,
  ppaytermInit,
  ppaytermDataInit,
  setLoaded,
  navigate,
  location,
  setSpaymentterm,
  setSpaymenttermData,
  spaytermInit,
  spaytermDataInit,
  setShowSQSM,
  setSQSM,
  setNavpostoedit
) => {
  const { USQSEdits, undoListUSQS } = useUSQSUndo();
  const { setWhdata, setInEuros, inEuros, setERlocked, setCurrencyChangeFlag } = useUSQS();
  useEffect(() => {
    if (qstoedit) {
      const loadusqstoedit = async () => {
        try {
          const response = await axiosPrivate.post("/api/qs/loadusqstoedit", {
            USQSID: qstoedit,
          });
          if (!response.data[0].exchangeRateUsdToEur && inEuros) {
            setInEuros(false);
            setUSQS(response.data[0]);
          }
          if (response.data[0].exchangeRateUsdToEur) setERlocked(true);
          if (!inEuros) {
            setUSQS(response.data[0]);
          }
          if (inEuros && response.data[0].exchangeRateUsdToEur) {
            setUSQS(response.data[0]);
            setCurrencyChangeFlag((prev) => !prev);
          }
          setLoaded((prev) => !prev);
          USQSEdits.current = [];
          undoListUSQS.current = [];
        } catch (err) {
          navigate("/login", { state: { from: location }, replace: true });
          // console.log(err);
        }
      };
      const loadusqsdatatoedit = async () => {
        try {
          // const response = await axiosPrivate.post("/api/qs/loadusqsdatatoedit", {
          //   USQSID: qstoedit,
          // });
          await axiosPrivate
            .post("/api/qs/loadusqsdatatoedit", {
              USQSID: qstoedit,
            })
            .then(async (response) => {
              // console.log(response.data[0]);
              setUSQSData(response.data[0]);
              await axiosPrivate.post("/api/qs/loadUSQSwhadata", { WGP: response.data[0].WGP }).then((response1) => {
                if (response1.message === "No matching WGP.") {
                  return;
                }
                if (response1.data && response1.data.length > 0) {
                  setWhdata(response1.data[0]);
                  setNavpostoedit(response1.data[0].USposID);
                }
              });
            });
        } catch (err) {
          navigate("/login", { state: { from: location }, replace: true });
          // console.log(err);
        }
      };
      const loadUSQSpayterms = async () => {
        try {
          const response = await axiosPrivate.post("/api/qs/loadUSQSpayterms", {
            USQSID: qstoedit,
          });
          if (response.data.message === "No payterms exist.") {
            setPpaymentterm(ppaytermInit);
            setSpaymentterm(spaytermInit);
          } else {
            let ppayterms = response.data.filter((item) => item.origin === "purchase");
            let spayterms = response.data.filter((item) => item.origin === "sales");
            setPpaymentterm(ppayterms);
            setSpaymentterm(spayterms);
          }
        } catch (err) {
          navigate("/login", { state: { from: location }, replace: true });
          // console.log(err);
        }
      };
      const loadUSQSpaytermsdata = async () => {
        try {
          const response = await axiosPrivate.post("/api/qs/loadUSQSpaytermsdata", {
            USQSID: qstoedit,
          });
          if (response.data.message === "No payterms exist.") {
            setPpaymenttermData(ppaytermDataInit);
            setSpaymenttermData(spaytermDataInit);
          } else {
            let ppaytermsdata = response.data.filter((item) => item.origin === "purchase");
            let spaytermsdata = response.data.filter((item) => item.origin === "sales");
            setPpaymenttermData(ppaytermsdata);
            setSpaymenttermData(spaytermsdata);
          }
        } catch (err) {
          navigate("/login", { state: { from: location }, replace: true });
          // console.log(err);
        }
      };

      loadusqstoedit();
      loadusqsdatatoedit();
      loadUSQSpayterms();
      loadUSQSpaytermsdata();
      setSQSM("USQS loaded");
      setShowSQSM((prev) => !prev);
    }
  }, [qstoedit]);
};

export default useLoadQSToEdit;
